import LocationSelectWidget from '@components/locationSelectWidget';
import MaintenanceModeAlert from '@components/maintenanceModeAlert';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_location')({
  component: Location,
});

function Location() {
  const { locationId } = Route.useSearch();

  return (
    <>
      {locationId ? (
        <>
          <MaintenanceModeAlert />
          <Outlet />
        </>
      ) : (
        <LocationSelectWidget />
      )}
    </>
  );
}
